export enum TipsPart {
    title = 'title',
    // TODO remove 'location' when cleaning FF profile-creation-location-and-workplace
    location = 'location',
    locationAndWorkplace = 'locationAndWorkplace',
    tags = 'tags',
    price = 'price',
    phone = 'phone',
    languages = 'languages',
}
